import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { auth } from '../firebase';
import './login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetSuccess, setResetSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const redirectPath = location.state?.from || '/admin';
        navigate(redirectPath);
      }
    });

    return () => unsubscribe();
  }, [navigate, location]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setResetSuccess('');
    setIsLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      console.error('Login error:', error);
      setError('Ugyldig email eller adgangskode. Prøv igen.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError('Indtast din email-adresse først');
      return;
    }

    setError('');
    setResetSuccess('');
    setIsResetLoading(true);
    
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSuccess('En email med link til nulstilling af adgangskode er blevet sendt.');
    } catch (error) {
      console.error('Reset password error:', error);
      setError('Kunne ikke sende nulstillingsmail. Kontrollér at email er korrekt.');
    } finally {
      setIsResetLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src="/media/logo/psykologiskperspektiv-logo.avif" alt="Psykologisk Perspektiv" />
        </div>
        <h1>Admin Login</h1>
        
        {error && <div className="login-error">{error}</div>}
        {resetSuccess && <div className="login-success">{resetSuccess}</div>}
        
        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Adgangskode</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Logger ind...' : 'Log ind'}
          </button>

          <button 
            type="button"
            className="forgot-password-button"
            onClick={handleResetPassword}
            disabled={isResetLoading}
          >
            {isResetLoading ? 'Sender email...' : 'Glemt adgangskode?'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
